import { IconButton, Tooltip } from "@kaltura/ds-react-components";
import { Chat24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { useSidebarLayoutContext } from "@kaltura/ds-react-layouts";
import { useEmbeddedCncWidgetContext } from "@kaltura/mediaspace-shared-contexts";

/**
 * Comments button that opens/closes C&C comments tab when clicking
 */
export const CncComments = () => {
    const { cncWidget } = useEmbeddedCncWidgetContext();
    const sendButtonAnalytics = useButtonAnalytics();
    const sidebarLayout = useSidebarLayoutContext();

    const onButtonClick = () => {
        // Jump to the comments tab within C&C:
        const changedToComments = cncWidget?.startComments?.();
        if (!sidebarLayout.isOpened || sidebarLayout.activeButtonId !== "cnc" || changedToComments) {
            // The comments tab wasn't focused before - open the sidebar and go to the C&C button
            sidebarLayout.setActiveButtonId("cnc");
            sidebarLayout.setIsOpened(true);
            sendButtonAnalytics("Media - Go to C&C comments", ButtonClickAnalyticsType.EXPAND);
        }
        else {
            // The comments tab was already focused when clicking the button - close the sidebar.
            sidebarLayout.setIsOpened(false);
            sendButtonAnalytics("Media - Close C&C comments", ButtonClickAnalyticsType.COLLAPSE);
        }
    };

    return (
        <Tooltip title={translate("Toggle comments")}>
            <IconButton variant={"borderless"} size={"medium"} color={"secondary"} onClick={onButtonClick}>
                <Chat24Icon />
            </IconButton>
        </Tooltip>
    );
};
